// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2K5Yn","author":"Table_author__22NYO","authorImage":"Table_authorImage__1KsHp","unreadRow":"Table_unreadRow__1ZAD_"};